<script setup lang="ts">
  import { isString } from '@borg/utils';
  import { AuthFormConfig, injectAuthForm } from '@/components/Auth/useAuthForm';

  definePageMeta({
    showHeader: false,
    showFooter: false,
  });

  const { t } = useI18n();
  const authForm = injectAuthForm();
  const userStore = useUserStore();
  const router = useRouter();
  const config = useRuntimeConfig();

  function getTitle(tab: AuthFormConfig['tab']) {
    switch (tab) {
      case 'login':
        return t('SIGN_UP_PAGE.LOGIN_TITLE');
      case 'register':
        return t('SIGN_UP_PAGE.REGISTER_TITLE');
      case 'forgotten_password':
        return t('SIGN_UP_PAGE.FORGOTTEN_PASSWORD_PAGE_TITLE');
      case 'new_password':
        return t('SIGN_UP_PAGE.NEW_PASSWORD_PAGE_TITLE');
      case 'verify':
        return t('SIGN_UP_PAGE.VERIFY_PAGE_TITLE');
    }
  }

  function getDescription(tab: AuthFormConfig['tab']) {
    switch (tab) {
      case 'login':
        return t('SIGN_UP_PAGE.LOGIN_DESCRIPTION');
      case 'register':
        return t('SIGN_UP_PAGE.REGISTER_DESCRIPTION');
      case 'forgotten_password':
        return t('SIGN_UP_PAGE.FORGOTTEN_PASSWORD_PAGE_TITLE');
      case 'new_password':
        return t('SIGN_UP_PAGE.NEW_PASSWORD_PAGE_TITLE');
      case 'verify':
        return t('SIGN_UP_PAGE.VERIFY_PAGE_TITLE');
    }
  }

  const title = computed(() => getTitle(authForm.config.tab));
  const description = computed(() => getDescription(authForm.config.tab));
  const baseUrl = `https://${config.public.project.domain}`;
  const canonicalUrl = `${baseUrl}${router.currentRoute.value.path.toString()}`;

  useHead({
    title: title,
    meta: [{ name: 'description', content: description }],
    link: [{ rel: 'canonical', href: canonicalUrl }],
  });

  useSeoMeta({
    ogTitle: title,
    ogDescription: description,
  });

  authForm.reset();
  authForm.setConfig({
    showLogo: true,
  });

  function onSuccess() {
    userStore.loginState = 'inProgress';
    const {
      query: { redirect },
    } = useRoute();

    window.location.href = isString(redirect) ? `${redirect}` : '/';
  }
</script>

<template>
  <AuthFormPageContainer>
    <AuthForm @success="onSuccess" />
  </AuthFormPageContainer>
</template>
